exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.track iframe{height:400px\n}\n.map-container{width:100% !important\n}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/tms-docker-build/frontend/shipper/src/modules-v2/indent/views/document-v2/index.vue"],"names":[],"mappings":";AACA,cAAc,YAAY;CACzB;AACD,eAAe,qBAAqB;CACnC","file":"index.vue","sourcesContent":["\n.track iframe{height:400px\n}\n.map-container{width:100% !important\n}"],"sourceRoot":""}]);

// exports
